/* ---------- Tooltips for anything with a data-tip attribute ---------- */

export type Tooltips = ReturnType<typeof initTooltips>;

export function initTooltips() {
  const tipEl = document.createElement("div");
  tipEl.className = "tip";
  tipEl.setAttribute("aria-hidden", "true");
  document.body.appendChild(tipEl);
  let shownFor: HTMLElement | null = null;
  function show(el: HTMLElement) {
    shownFor = el;
    tipEl.textContent = el.dataset.tip ?? "";
    const r = el.getBoundingClientRect();
    const tw = tipEl.offsetWidth,
      th = tipEl.offsetHeight;
    tipEl.style.left =
      Math.max(8, Math.min(innerWidth - tw - 8, r.left + r.width / 2 - tw / 2)) + "px";
    tipEl.style.top = r.top - th - 8 + "px";
    tipEl.classList.add("show");
  }
  function hide() {
    shownFor = null;
    tipEl.classList.remove("show");
  }
  const tipTarget = (e: Event) => (e.target as Element).closest<HTMLElement>("[data-tip]");
  document.addEventListener("pointerover", (e) => {
    const el = tipTarget(e);
    if (el && e.pointerType === "mouse") show(el);
  });
  document.addEventListener("pointerout", (e) => {
    const el = tipTarget(e);
    if (el && !el.contains(e.relatedTarget as Node | null)) hide();
  });
  document.addEventListener("focusin", (e) => {
    const el = tipTarget(e);
    if (el && el.matches(":focus-visible")) show(el);
  });
  document.addEventListener("focusout", hide);
  return {
    hide,
    /** Updates the tip if it is showing for this element, after its label changed. */
    refresh(el: HTMLElement) {
      if (shownFor === el) show(el);
    },
  };
}
